export default "__VITE_ASSET__Beo4iyJE__"